import { useInterval } from '@chakra-ui/react';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import * as React from 'react';

dayjs.extend(isBetween);

export const useReactiveEventTiming = ({
  startDate,
  endDate,
  isReactive = true,
}: {
  startDate: Date;
  endDate: Date;
  isReactive?: Boolean;
}) => {
  const getIsEventFuture = () => {
    return dayjs().isBefore(dayjs(startDate).subtract(5, 'minutes'));
  };
  const getIsEventLive = () => {
    return dayjs().isBetween(
      dayjs(startDate).subtract(5, 'minutes'),
      dayjs(endDate)
    );
  };
  const getIsEventPast = () => {
    return dayjs().isAfter(dayjs(endDate));
  };

  const [isEventFuture, setIsEventFuture] = React.useState(getIsEventFuture);
  const [isEventLive, setIsEventLive] = React.useState(getIsEventLive);
  const [isEventPast, setIsEventPast] = React.useState(getIsEventPast);

  useInterval(
    () => {
      setIsEventFuture(getIsEventFuture());
      setIsEventLive(getIsEventLive());
      setIsEventPast(getIsEventPast());
    },
    isEventPast || !isReactive ? null : 10000
  );

  return {
    isEventFuture,
    isEventLive,
    isEventPast,
  };
};
